import { axiosInstance } from "@src/shared/api";
import { USER_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export interface AccountDeletionRequestDto {
    login?: string;
    code?: string;
    password?: string;
}

export const deleteUserAccount = (data: AccountDeletionRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstance.delete(USER_API_URL.deleteUserAccount(), {
    data,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
